/**
 * Load CSRF token in to jQuery Ajax requests
*/

import EventBus from './../event-bus.js'
import jQuery from 'jquery'

const CsrfToken = {
    
    init() {

        jQuery.ajaxSetup({
            headers: {
                'X-CSRF-Token':     jQuery('#csrf-token').attr('content'),
                'X-Requested-With': 'XMLHttpRequest'
            },
            xhrFields: {
                withCredentials: true
            }
        })
        
    }
    
}

EventBus.subscribe('init-modules', CsrfToken.init)

export default CsrfToken